<template>
  <v-app>
    <v-main style="padding: 0px 0px 0px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
